import type { ApolloCache } from "@apollo/client/cache"

import { evict } from "shared/api/evict"
import { ProjectParentTypename } from "shared/types/Project"

import { restoreProjectChildrenSorting } from "./restoreProjectChildrenSorting"

export function evictProjectChildAndSort({
  id,
  typename,
  parentID,
  parentType,
  cache
}: {
  id: string
  typename: string
  parentID: string
  parentType: ProjectParentTypename
  cache: ApolloCache<object>
}) {
  evict({ cache, id, typename })
  restoreProjectChildrenSorting(parentID, parentType, cache)
}
